import React from "react";

import NewAssessment from "@Components/assessment/NewAssessment";
import CurrentAssessments from "@Components/assessment/CurrentAssessments";
import { getTutorialTip } from "@Components/assessment/helpers";
import StudentAssessment from "@Components/assessment/StudentAssessments";
import TemplateDesigner from "@Components/assessment/TemplateDesigner";
import { IAssessmentTab, isValidTab } from "@Components/assessment/types";
import PageHelmet from "@Components/shared/PageHelmet";
import { hasCapabilityContext, useSearchParams } from "@Utils";
import { Col, Row, Tabs } from "antd";
import { GroupContext } from "@Constants";
import GuidanceDrawer from "@Components/shared/GuidanceDrawer";

const AssessmentReviewPage: React.FC = () => {
    const { TabPane } = Tabs;
    const [searchParams, setSearchParams] = useSearchParams();
    const tabParam = searchParams.get("tab");
    const assessmentParam = searchParams.get("assessment");
    const activeTab: IAssessmentTab = isValidTab(tabParam) ? tabParam : "current";

    const handleTabClick = (newTab: string) => setSearchParams({ tab: newTab });

    const canCreate = hasCapabilityContext("Assessment/Create", GroupContext);
    const canViewCurrentPast = hasCapabilityContext("Assessment/GetInstances", GroupContext);

    return (
        <article className="assessments-review-page assessments-section">
            <PageHelmet name={"Assessment Review"} />
            <section>
                <Row gutter={[16, 16]}>
                    <Col xs={24}>
                        <Tabs
                            activeKey={activeTab}
                            className="newUI-raised"
                            centered
                            onTabClick={handleTabClick} // using TabClick instead of TabChange so users can return to the list
                            type="card"
                        >
                            {canViewCurrentPast && (
                                <>
                                    <TabPane tab="Current" key="current">
                                        {activeTab === "current" && !assessmentParam && (
                                            <>
                                                <div className="guidance-container">
                                                    <GuidanceDrawer text={getTutorialTip("current")} />
                                                </div>
                                                <CurrentAssessments tab="current" />
                                            </>
                                        )}
                                    </TabPane>
                                </>
                            )}

                            {canCreate && (
                                <>
                                    <TabPane tab="New" key="new">
                                        <div className="guidance-container">
                                            <GuidanceDrawer text={getTutorialTip("new")} />
                                        </div>
                                        <NewAssessment tab="new" />
                                    </TabPane>
                                    <TabPane tab="Templates" key="templates">
                                        <div className="guidance-container">
                                            <GuidanceDrawer text={getTutorialTip("templates")} />
                                        </div>
                                        <TemplateDesigner />
                                    </TabPane>
                                </>
                            )}

                            <>
                                <TabPane tab="Assigned" key="assigned">
                                    <div className="guidance-container">
                                        <GuidanceDrawer text={getTutorialTip("assigned")} />
                                    </div>
                                    <StudentAssessment tab="assigned" />
                                </TabPane>
                                <TabPane tab="Submitted" key="submitted">
                                    <div className="guidance-container">
                                        <GuidanceDrawer text={getTutorialTip("submitted")} />
                                    </div>
                                    <StudentAssessment tab="submitted" />
                                </TabPane>
                                <TabPane tab="Completed" key="completed">
                                    <div className="guidance-container">
                                        <GuidanceDrawer text={getTutorialTip("completed")} />
                                    </div>
                                    <StudentAssessment tab="completed" />
                                </TabPane>
                            </>
                        </Tabs>
                    </Col>
                </Row>
            </section>
        </article>
    );
};

export default AssessmentReviewPage;
